/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfUserGroupDto } from '../../models/platform-api-result-of-user-group-dto';

export interface DeleteUsergroupsUsergroupidActionRemoveappAppid$Params {
  userGroupId: string;
  appId: string;
}

export function deleteUsergroupsUsergroupidActionRemoveappAppid(http: HttpClient, rootUrl: string, params: DeleteUsergroupsUsergroupidActionRemoveappAppid$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserGroupDto>> {
  const rb = new RequestBuilder(rootUrl, deleteUsergroupsUsergroupidActionRemoveappAppid.PATH, 'delete');
  if (params) {
    rb.path('userGroupId', params.userGroupId, {});
    rb.path('appId', params.appId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfUserGroupDto>;
    })
  );
}

deleteUsergroupsUsergroupidActionRemoveappAppid.PATH = '/api/usergroups/{userGroupId}/action/removeapp/{appId}';
